__webpack_require__.p = "https://hloja-digital-checkout.boticario.com.br/";